export default {"tabs":"Q1itKW_tabs","notice":"Q1itKW_notice","stage":"Q1itKW_stage","wrapper":"Q1itKW_wrapper","copy":"Q1itKW_copy",}